import { Menu } from "@headlessui/react";
import { Link } from "react-router-dom";
import { classNames } from "../../helpers/classNames";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";

const dropdownVariants = {
  hidden: { opacity: 0, scale: 0.95, transformOrigin: "top right" },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.15, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: { duration: 0.1, ease: "easeIn" },
  },
};

const ActionMenu = ({
  data,
  xPlacement = "right-0", // left-0, right-0
  dropdownContainer,
  flip = true,
  buttonClass,
  ...props
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <Menu.Button className="flex items-center justify-center">
            <div
              className={classNames(
                "relative text-base text-slate-500 bg-white w-6 h-6 flex items-center justify-center focus:ring-0 transition-all duration-200 rounded-md hover:text-primary",
                buttonClass
              )}>
              <i className="fa-regular fa-fw fa-ellipsis-vertical"></i>
            </div>
          </Menu.Button>

          <AnimatePresence>
            {open && (
              <Menu.Items
                static
                as={motion.div}
                variants={dropdownVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                className={classNames(
                  `absolute z-50 mt-2 origin-top-right rounded-md bg-white shadow-lg focus:outline-none border border-slate-200 py-1 w-32 ${xPlacement}`,
                  dropdownContainer
                )}>
                <div className="max-h-80 overflow-auto scroll-smooth scrollbar">
                  {data?.length > 0 &&
                    data.map((item, i) => (
                      <React.Fragment key={i}>
                        {item.link ? (
                          <Menu.Item>
                            {({ active }) => (
                              <Link
                                to={item.link}
                                className={classNames(
                                  "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                                  active ? "bg-gray-100 text-gray-900" : "",
                                  item?.class
                                )}>
                                {item.icon && <i className={classNames("fa-fw", item.icon)} />}
                                <span>{item.name}</span>
                              </Link>
                            )}
                          </Menu.Item>
                        ) : (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                type="button"
                                onClick={item?.onClick}
                                className={classNames(
                                  "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                                  item?.standout
                                    ? "!text-rose-600 hover:!bg-rose-600/10"
                                    : "!text-primary hover:!bg-primary/10",
                                  item?.class
                                )}>
                                {item?.icon && <i className={classNames("fa-fw", item?.icon)} />}
                                <span>{item?.name}</span>
                              </button>
                            )}
                          </Menu.Item>
                        )}
                      </React.Fragment>
                    ))}
                </div>
              </Menu.Items>
            )}
          </AnimatePresence>
        </>
      )}
    </Menu>
  );
};

export default ActionMenu;
